<template>
	<Base :path="src" :alt="alt" :fluid="fluid"/>
</template>
<script>
import Base from "@/vue/common/image/Base.vue";

export const CAT_NOTEBOOK = 'cat-notebook';
export const HOLDING_EURO = 'holding-euro';
export const HOLDING_NOTHING = 'holding-nothing';
export const IDEA_LIGHT_BULB = 'idea-light-bulb';
export const CLIPBOARD = 'clipboard';
export const WELCOME = 'welcome';
export const BREAK = 'break';
export const ROCKET = 'rocket';

const ALTS = {
	[CAT_NOTEBOOK]: 'Skilly sitzt mit Katze vor Notebook',
	[HOLDING_EURO]: 'Skilly hält Euro-Münze in der Hand',
	[HOLDING_NOTHING]: 'Skilly hält leere Hand offen',
	[IDEA_LIGHT_BULB]: 'Skilly hat eine Erleuchtung',
	[CLIPBOARD]: 'Skilly hält ein Clipboard',
	[WELCOME]: 'Skilly hält eine Willkommensgirlande über den Kopf',
	[BREAK]: 'Skilly ruht sich aus',
	[ROCKET]: 'Skilly fliegt mit Rakete',
};

export default {
	components: {
		Base
	},

	props: {
		avatar: {
			type: String,
			required: true
		},
		fluid: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	computed: {
		src ()
		{
			return 'avatar/' + this.avatar + '.svg';
		},
		alt ()
		{
			return ALTS[this.avatar];
		}
	}
}
</script>
